import { BaseModel } from '../base-model';
import { ISmartSuggest } from '.';

export interface IDemandSmartSuggestion {
  Input?: string;
  GoalId?: number | null;
  SelectedInputEntries?: ISmartSuggest[];
  SelectedRegionEntries?: any;
}
export class DemandSmartSuggestion extends BaseModel<IDemandSmartSuggestion> implements IDemandSmartSuggestion {
  Input?: string;
  GoalId?: number | null;
  SelectedInputEntries?: ISmartSuggest[];
  SelectedRegionEntries?: any;
  /**
   *
   */
  constructor(selectedInput?: ISmartSuggest[], regionDestination?: any,
    option?: { input?: string, goalId?: number }) {
    super();
    this.SelectedInputEntries = selectedInput;
    this.SelectedRegionEntries = regionDestination;
    this.Input = option.input;
    this.GoalId = option.goalId;
  }
}